// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"fc8c8cde","553":"9c8cd80f","620":"356d0f43","751":"4bce6909","756":"a052aa28","787":"bcbf1bec"}[chunkId] + ".chunk.js";
};